import { IAction, StateStatus } from 'redux/utils/common';
import * as Types from './type';
import * as ProductService from 'services/api/product';
import * as CategoryService from 'services/api/category';

import { LanguagesEnum } from 'constants/languages';
import { IDataItems, IDescriptionData } from 'services/api/category';

export interface IState {
  segments: {
    data: ProductService.ISegments | null;
    status: StateStatus | null;
  };
  categoryBasicInfo: {
    data: CategoryService.IDataItems | null;
    status: StateStatus | null;
  };
  updateBasicInfoStatus: StateStatus | null;
  temporaryDescription: IDescriptionData[];
  temporaryName: IDescriptionData[];
  categoryList: {
    status: StateStatus | null;
    data: IDataItems[] | null;
  };
}

const initialState: IState = {
  segments: {
    data: null,
    status: null,
  },
  categoryBasicInfo: {
    data: null,
    status: null,
  },
  updateBasicInfoStatus: null,
  temporaryDescription: [],
  temporaryName: [],
  categoryList: {
    status: null,
    data: null,
  },
};

const CategoryEditReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_SEGMENTS:
      return {
        ...state,
        segments: {
          ...state.segments,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_CATEGORY_BASIC_INFO:
      return {
        ...state,
        categoryBasicInfo: {
          ...state.categoryBasicInfo,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.UPDATE_CATEGORY_BASIC_INFO:
      return {
        ...state,
        updateBasicInfoStatus: action.status || null,
      };
    case Types.UPDATE_DESCRIPTION_TEMPORARY:
      return {
        ...state,
        temporaryDescription: action.data,
      };
    case Types.UPDATE_NAME_TEMPORARY:
      return {
        ...state,
        temporaryName: action.data,
      };
    case Types.SET_CATEGORY_LIST:
      return {
        ...state,
        categoryList: {
          ...state.categoryList,
          status: action.status || null,
          data: action.data,
        },
      };
    default:
      return {
        ...state,
      };
  }
};

export default CategoryEditReducer;
